export { MapViewProps, MapHandle, DEFAULT_REGION } from './types';

// Metro resolves './Map' to Map.native.tsx on iOS/Android and Map.web.tsx on web.
// Using the bare module name (no `.web` suffix) is what enables that platform fork.
export { default } from './Map';

// Additional map components
export { AddressSearchBar } from './AddressSearchBar';
export { StructureMarker, StructureClusterMarker } from './StructureMarker';
export { StructureDetailSheet } from './StructureDetailSheet';
